<template>
    <div class="play-area">
        <div class="video" v-if="videoState">
            <player :videoUrl="videoUrl" :coverUrl="`${videoInfo.coverUrl}small.jpg`" ></player>
        </div>
        <div class="video-info rel">
            <update-dialog @updateTitleState="updateTitleChange" v-model="videoTitle" v-if="updateTitle"></update-dialog>
            <h2 v-else>{{title}}<i v-on:click="updateTitle = !updateTitle" class="ui-icon icon-icon_edit"></i></h2>
            <p class="desc">{{videoInfo.deviceName}} {{time}}  |  {{size}}MB</p>
            <ul class="ui-button-list">
                <button class="downloadButton ui-button empty-button short-button" v-on:click="download"><span class="ui-logo icon-icon_download"></span>{{ $t('video.download') }}</button>
                <button class="ui-button empty-button short-button" v-on:click="delVideoState = !delVideoState"><span class="ui-logo icon-bin-line"></span>{{ $t('video.del') }}</button>
                <a id="share-button" class="ui-button empty-button short-button" href="https://reolink.com/submit-videos/" target="_blank" v-if="!FEATURE('video.share_video')"><span class="ui-logo icon-icon_share"></span>{{ $t('video.share') }}</a>
            </ul>
            <confirm-dialog @confirmAction="delVideoAction" v-if="delVideoState"></confirm-dialog>
        </div>
    </div>
</template>

<script>

import player from '@/components/player';

import updateDialog from '@/components/updateDialog';

import confirmDialog from '@/basic/confirmDialog';

import { videoplayerUrl, deleteVideo, updateVideoTitle } from '@/api/cloud';

import { timeResolve } from '@/common/js/date';

import { mapActions } from 'vuex';

import { downLoad, goTop } from '@/common/js/utils';

export default {

    components: {

        player,
        updateDialog,
        confirmDialog

    },

    props: {

        videoInfo: {
            type: Object,
            required: true
        }

    },

    data () {

        return {
            
            updateTitle: false,
            videoId: this.$route.query.videoId,
            videoUrl: '',
            downloadUrl: '',
            videoState: false,
            videoTitle: this.videoInfo.title,
            delVideoState: false

        };

    },

    computed: {

        time () {

            let {

                year,
                month,
                dateOfMonth,
                hourOf12Decimal: hour,
                noon,
                minute,
                second

            } = timeResolve( this.videoInfo.createdAt );

            let time = `${hour}:${minute}:${second} ${noon}`;

            return `${year}/${month}/${dateOfMonth} ${time}`;

        },

        title () {

            let {

                hourOf12Decimal: hour,
                noon,
                minute,
                second

            } = timeResolve( this.videoInfo.createdAt );

            let time = `${hour}:${minute}:${second} ${noon}`;

            if ( this.videoTitle.length === 0 ) {

                return time;

            } else {

                return this.videoTitle;

            }

        },

        size () {

            let size = ( this.videoInfo.size / 1024 / 1024 ).toFixed( 2 );

            if ( size === '0.00' ) {

                size = 0.01;

            }
            
            return size;

        }

    },

    created () {

        this.getVideoPlayUrl( this.videoId, 'play' );
        this.getVideoPlayUrl( this.videoId, 'downLoad' );

    },

    methods: {

        updateTitleChange ( value ) {

            this.updateTitle = value;

        },

        async getVideoPlayUrl ( videoId, type ) {

            let video = await videoplayerUrl( videoId, type );

            if ( type === 'play' ) {

                this.videoUrl = video.url;

            } else {

                this.downloadUrl = video.url;

            }
            
            this.videoState = true;

        },

        download ( ) {

            downLoad( this.downloadUrl, `${this.videoId}.mp4` );

        },

        deleteVideoAction ( ) {

            deleteVideo( parseInt( this.videoId )).then( res => {

                goTop();
                this.topInfoToggle({

                    type: 'success',
                    msgIndex: 'suc.delete_video'

                });

                setTimeout(() => {

                    this.$router.push({path: '/user/cloud-library/'});

                }, 3000 );

            }).catch( err => {

                goTop();
                this.topInfoToggle({

                    type: 'error',
                    msgIndex: 'errors.err_del_video'

                });
                console.error( err );

            });

        },

        delVideoAction ( value ) {

            if ( value ) {

                this.deleteVideoAction();

            }

            this.delVideoState = false;

        },

        ...mapActions( [

            'topInfoToggle'

        ] )

    },

    watch: {
        
        videoTitle ( title ) {

            if ( title !== this.videoInfo.title ) {

                updateVideoTitle( this.videoId, title ).then( res => {

                }).catch( err => {

                    goTop();
                    this.topInfoToggle({

                        type: 'error',
                        msgIndex: 'errors.err_update_title'

                    });
                    console.error( err );

                });

            }

        },

        videoInfo ( val ) {

            this.videoId = this.$route.query.videoId;

            this.getVideoPlayUrl( this.videoId, 'play' );
            this.getVideoPlayUrl( this.videoId, 'downLoad' );

            this.videoTitle = val.title;

        }

    }

};

</script>

<style lang="less">

    .ui-button-list{
        font-size: 0;
    }

    @media screen and ( min-width: 1200px ) {
        .player-mod main .video{
            width: 100%;
            height: 6.6rem;
            background-color: #f1f1f1;
            margin-bottom: .2rem;
        }

        .play-area .video-info h2{
            font-weight: 500;
            font-size: .26rem;
            margin-bottom: .1rem;
        }

        .play-area .video-info{
            margin-bottom: .2rem;
            border-bottom: 1px solid #ccc;
        }

        .play-area .video-info h2 .ui-icon{
            margin-right: .3rem;
        }

        .play-area .video-info .desc{
            color: #666;
            font-size: .16rem;
            font-weight: 500;
            margin-bottom: .2rem;
        }

        .play-area .video-info .ui-button{
            font-size: .18rem;
            margin-bottom: .26rem;
        }

        .play-area .video-info .ui-button + .ui-button{
            margin-left: .4rem;
        }

        .play-area .video-info h2 i{
            color: @theme;
            font-size: .3rem;
            margin-left: .1rem;
            cursor: pointer;
        }

    }

    @media screen and ( max-width: 1199px ) {
        .player-mod .video-info{
            padding: 0 15px;
        }

        .player-mod .video-info h2{
            color: #333;
            font-weight: 500;
            font-size: .42rem;
            margin-bottom: .2rem;
        }
 
        .player-mod .video-info .desc{
            color: #666;
            font-size: .26rem;
            font-weight: 500;
            margin-bottom: .25rem;
        }

        .play-area .video-info .ui-button + .ui-button{
            margin-left: 0;
        }

        .play-area .video-info .ui-button:last-child{
            margin-left: 0.3rem;
        }

        .play-area{
            padding-bottom: .44rem;
            border-bottom: 1px solid #ccc;
            margin-bottom: .44rem;
        }

        .play-area .video-info h2 i{
            color: @theme;
            font-size: .45rem;
            margin-left: .2rem;
        }

        .downloadButton{
            display: none !important;
        }

        .play-area .video-info .ui-button .ui-logo{
            font-size: 0.36rem;
            top: 0.06rem;
        }
        
    }

</style>



// WEBPACK FOOTER //
// src/view/videos/videoPlayer.vue